import { INCLUSION_CONSTANTS } from "./constants";
import { Box, Heading, Stack, Wrap, WrapItem } from "@chakra-ui/react";
import OfferingBgImage from "public/openStack/background.png";
import PageLayout from "@/layouts/pageLayout";
import { AdvantageCard } from "@/components/advantageCard";

const InclusionComponent = () => {
  return (
    <Box backgroundImage={OfferingBgImage.src} backgroundSize="cover" pb={20}>
      <PageLayout marginTop={0}>
        <Stack spacing={8}>
          <Heading
            as="h2"
            fontWeight={"400"}
            textAlign={"center"}
            fontSize={"40px"}
            my={12}
          >
            Migration Stack Includes:
          </Heading>
          <Wrap spacing={{ base: 8, md: 12 }} justify={"center"} pb={4}>
            {INCLUSION_CONSTANTS.map((item, index) => (
              <WrapItem
                key={index}
                w={{
                  base: "100%",
                  sm: "280px",
                  md: "360px",
                  lg: "300px",
                  xl: "370px",
                  "2xl": "480px",
                }}
              >
                <AdvantageCard key={index} {...item} bgColor="white" />
              </WrapItem>
            ))}
          </Wrap>
        </Stack>
      </PageLayout>
    </Box>
  );
};

export default InclusionComponent;
